import { combineReducers } from 'redux';

import auth from './auth';
import registrationSettings from './registrationSettings';

export default combineReducers({
  auth,
  registrationSettings,
});
